import React, { Component } from 'react';
import {ref} from '../config/firebase';
import Nav from './components/Nav';
import Footer from './components/Footer';
import {Tabs, Tab} from 'react-bootstrap';

import Error from '../helpers/Error';

export default class Education extends Component {
	constructor(props) {
		super(props);
		this.state = {
			aKey: 1,
			items: [],
			edit: false,
			err: null,
			status: null,
			key: ''
		};
		this.dbItems = ref.child('education');
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleSelect = this.handleSelect.bind(this);
	}


	componentWillMount() {
		this.dbItems.on('value', dataSnapshot => {
			var items = [];
			dataSnapshot.forEach(function(childSnapshot) {

				var item = childSnapshot.val();
				
				item['.key'] = childSnapshot.key;
				items.push(item);

			});

			this.setState({items: items});

		});
		
	}

	componentWillUnmount() {
		this.dbItems.off();
	}

	handleSubmit(e) {
		e.preventDefault();

		if( this.period.value !== "" &&
			this.major.value !== "" &&
			this.achievement.value !== "" &&
			this.place.value !== "" &&
			this.link.value !== "" ) {
			
			if(this.state.edit) { // edit
				this.dbItems.child(this.state.key).update({
					period: this.period.value,
					major: this.major.value,
					achievement: this.achievement.value,
					place: this.place.value,
					link: this.link.value
				});
				this.setState({
					err: "Success Edit Education!",
					status: null,
					edit: false,
					key: ''
				});
				this.handleSelect(1);
			}
			else { // create
				this.dbItems.push({
					period: this.period.value,
					major: this.major.value,
					achievement: this.achievement.value,
					place: this.place.value,
					link: this.link.value
				})

				this.setState({err: "Success Insert New Education!", status: null});
			}

			// empth value
			this.period.value = '';
			this.major.value = '';
			this.achievement.value = '';
			this.place.value = '';
			this.link.value = '';
			
		}
		else {
			this.setState({err: "Something Wrong", status:'err'});
		}

	}

	removeItem(key) {
		this.dbItems.child(key).remove();
	}

	editItem(key) {
		this.dbItems.child(key).once('value', dataSnapshot => {

			var data = dataSnapshot.val();

			// set back value
			this.period.value = data.period;
			this.major.value = data.major;
			this.achievement.value = data.achievement;
			this.place.value = data.place;
			this.link.value = data.link;
			
			this.handleSelect(2);

			this.setState({
				edit:true,
				key: key
			});
		});

		
	}

	handleSelect(aKey) {
		this.setState({aKey});
	}

  render () {
  	var dat = [ 'Education List', 'Create Education' ];
  	var i = 0;
  	var _this = this;

    return (
    	<div>
    		<Nav />
    		<div className="container">
    			<div className="row">
    				<h1>EXPERIENCE</h1>
    				<Error err={this.state.err} status={this.state.status}/>
    				<Tabs activeKey={this.state.aKey} onSelect={this.handleSelect} id="eduTab">
    					<Tab eventKey={1} title={dat[0]}>
							<h3>{dat[0]}</h3>
						    <table className="table table-bordered">
								<thead>
									<tr>
										<th>No</th>
										<th>Period</th>
										<th>Major</th>
										<th>Achievement</th>
										<th>Place</th>
										<th>Action</th>
									</tr>
								</thead>

								<tbody>
									{
										this.state.items.map(function(item) {

											return (
												<tr key={item['.key']}>
													<td>{++i}.</td>
													<td>{item.period}</td>
													<td>{item.major}</td>
													<td><ul>{item.achievement.split(";").map(i => {
															return <li key={Math.random()}>{i}</li>
														})}</ul></td>
													<td><a href={item.link} target="_blank" rel="noopener noreferrer">{item.place}</a></td>
													<td>
														<a data-toggle="tab" className="btn btn-info" href="#create" onClick={()=>{_this.editItem(item['.key'])}}>Edit</a> &nbsp;
														<a className="btn btn-danger" onClick={() => { _this.removeItem(item['.key']) }}>Delete</a>
													</td>
												</tr>
											);
										})
									}
									
								</tbody>
							</table>
    					</Tab>
    					
    					<Tab eventKey={2} title={(this.state.edit)? 'Edit Education' : dat[1]}>
							<h3>{(this.state.edit)? 'Edit Education' : dat[1]}</h3>
						    <form onSubmit={this.handleSubmit}>
			        			<div className="form-group">
								    <label>Period</label>
								    <input type="text" ref={(period) => this.period = period} className="form-control" placeholder="Ex: 2000 - 2012"/>
							  	</div>	
							  	<div className="form-group">
								    <label>Major</label>
								    <input type="text" ref={(major) => this.major = major} className="form-control" placeholder="Ex: Formal Education"/>
							  	</div>
							  	<div className="form-group">
								    <label>Achievement</label>
								    <textarea ref={(achievement) => this.achievement = achievement} className="form-control" placeholder="Ex: Primary School; Junior High School; Senior High School"></textarea>
								    
							  	</div>	
							  	<div className="form-group">
								    <label>Place</label>
								    <input type="text" ref={(place) => this.place = place} className="form-control" placeholder="Ex: Methodist-2 Medan"/>
							  	</div>	
							  	<div className="form-group">
								    <label>Link Place</label>
								    <input type="text" ref={(link) => this.link = link} className="form-control" placeholder="Ex: http://www.methodist2mdn.sch.id/"/>
							  	</div>	
							  
							  	
							  <button type="submit" className="btn btn-default">{(this.state.edit)?'Edit':'Create'}</button> &nbsp;
							  <button type="reset" className="btn btn-warning">Cancel</button>
							</form>
    					</Tab>
    				</Tabs>
		    		
				</div>
			</div>
			<Footer/>
    	</div>
      
    )
  }
}


// WEBPACK FOOTER //
// ./src/auth_pages/Education.js